import { useRef, useState } from "react";
import { FaChevronLeft, FaDoorClosed, FaDoorOpen, FaRegHandPointLeft } from "react-icons/fa";

interface SubSideBarProps {
    sidebarOpen: boolean;
    setSidebarOpen: React.Dispatch<React.SetStateAction<any>>
    children: React.ReactNode;
}

function SubSideBar2({ sidebarOpen, setSidebarOpen, children }: SubSideBarProps) {


    const toggleSidebar = () => {

        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div
            className={`flex z-0 py-8  overflow-x-auto whitespace-nowrap border-x bg-gray-900 border-gray-700 transition-all duration-500 transform shadow-lg  ${sidebarOpen ? "sm:w-64 w-60 translate-x-0" : "w-0 -translate-x-full border-none"}`}
            tabIndex={0}
        >
            {children}
            <button
                className="absolute bottom-0 right-0 p-3 text-white text-menu cursor-pointer"
                onClick={toggleSidebar}
            >
                <FaRegHandPointLeft />
            </button>
        </div>
    );
}

export { SubSideBar2 };